import {useEffect, useState} from "react";

interface IOneSystem{
    title:string;
    content:string;
    img:any;
}
interface  IUseProductSystem{
    totalList:IOneSystem[];
    // scale:number;
}

const isPc = function (){
    return window.innerWidth >= 1280;
}
export default function useProductSystem(props:IUseProductSystem){
    const { totalList} = props;
    const [showMore, setShowMore] = useState(!isPc());
    const finalList = !showMore ? totalList: totalList.slice(0,4);
    useEffect(()=>{
        const listener = function(){
            setShowMore(!isPc());
        }
        window.addEventListener('resize',listener,false);

        // return window.removeEventListener('resize',listener);

    },[])
    return {
        finalList,
        showMore, setShowMore,
    }
}
